// src/constants/homePageContent.ts

export const ABOUT_PAGE_CONTENT = {
    dayGlance: {
        sectionTitle: "Une Journée Chez Nous",
        paragraph: "Chaque journée est une aventure joyeuse et rythmée par des moments simples et précieux : créations artistiques, jeux en plein air, siestes réparatrices et éclats de rire. Nous concevons chaque activité avec amour et attention" +
            " pour éveiller la curiosité, renforcer la confiance en soi et cultiver le plaisir d'apprendre",
    },
    history: {
        title: "Découvrez notre histoire",
        paragraph: "Depuis plus de 12 ans, ma garderie familiale rayonne d'une passion pour l'éveil et le bien-être des tout-petits. En tant qu'éducatrice qualifiée et maman de cinq enfants moi-même, j'ai créé un lieu où mon approche privilégie la douceur, l'attention personnalisée et le respect de la personnalité de chaque enfant. \n" +
            "\n" +
            "Créée avec beaucoup de cœur et de dévouement, ma garderie a grandi progressivement " +
            "grâce à la confiance et au soutien des familles qui m'ont accompagnée tout au long du chemin.",
    },
    programOverView: {
        title: "Aperçu des Programmes",
        paragraph:""
    }
};
